import React from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import FormAssembly from "../../../components/FormAssembly/FormAssembly";
import store from "../../../store";
import {Helmet} from "react-helmet";


const lostOrDamagedClaimForm = () => {
  return (
    <div className="wrapper">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Manage" ? row.sections.map((section) => {
                        return section.title === "File a Claim" ? section.subsections.map((subsection) => {
                                    return subsection.title === "Claim Form" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                })
                                : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs/>
      <h1 className="two-three-rows__title">Lost or Damaged Claim Form</h1>
      <div className="iframe-box-wrapper">
        <FormAssembly formReferenceName="LOST_OR_DAMAGED_CLAIM_FORM"/>
      </div>
    </div>
  );
};

export default lostOrDamagedClaimForm;



// WEBPACK FOOTER //
// ./src/pages/manage/FileAClaim/LostOrDamagedClaimForm.js